import importer from "common/importer";

const getLoyaltyMilestones = importer(
  "Sagas/PublicContent/getLoyaltyMilestones/main"
);
const getLoyaltyMilestonesSuccess = importer(
  "Sagas/PublicContent/getLoyaltyMilestones/success"
);
const getLoyaltyMilestonesFailure = importer(
  "Sagas/PublicContent/getLoyaltyMilestones/failure"
);

const getMessages = importer("Sagas/PublicContent/getMessages/main");
const getMessagesSuccess = importer("Sagas/PublicContent/getMessages/success");
const getMessagesFailure = importer("Sagas/PublicContent/getMessages/failure");

const getCenters = importer("Sagas/PublicContent/getCenters/main");
const getCentersSuccess = importer("Sagas/PublicContent/getCenters/success");
const getCentersFailure = importer("Sagas/PublicContent/getCenters/failure");

const getCentersForMobile = importer(
  "Sagas/PublicContent/getCentersForMobile/main"
);
const getCentersForMobileSuccess = importer(
  "Sagas/PublicContent/getCentersForMobile/success"
);
const getCentersForMobileFailure = importer(
  "Sagas/PublicContent/getCentersForMobile/failure"
);

const getGenders = importer("Sagas/PublicContent/getGenders/main");
const getGendersSuccess = importer("Sagas/PublicContent/getGenders/success");
const getGendersFailure = importer("Sagas/PublicContent/getGenders/failure");

const getCountries = importer("Sagas/PublicContent/getCountries/main");
const getCountriesSuccess = importer(
  "Sagas/PublicContent/getCountries/success"
);
const getCountriesFailure = importer(
  "Sagas/PublicContent/getCountries/failure"
);

const getAllStates = importer("Sagas/PublicContent/getAllStates/main");
const getAllStatesSuccess = importer(
  "Sagas/PublicContent/getAllStates/success"
);
const getAllStatesFailure = importer(
  "Sagas/PublicContent/getAllStates/failure"
);

const getLanguages = importer("Sagas/PublicContent/getLanguages/main");
const getLanguagesSuccess = importer(
  "Sagas/PublicContent/getLanguages/success"
);
const getLanguagesFailure = importer(
  "Sagas/PublicContent/getLanguages/failure"
);

const getPhoneTypes = importer("Sagas/PublicContent/getPhoneTypes/main");
const getPhoneTypesSuccess = importer(
  "Sagas/PublicContent/getPhoneTypes/success"
);
const getPhoneTypesFailure = importer(
  "Sagas/PublicContent/getPhoneTypes/failure"
);

const getEthnicityOptions = importer(
  "Sagas/PublicContent/getEthnicityOptions/main"
);
const getEthnicityOptionsSuccess = importer(
  "Sagas/PublicContent/getEthnicityOptions/success"
);
const getEthnicityOptionsFailure = importer(
  "Sagas/PublicContent/getEthnicityOptions/failure"
);

const saveContactForm = importer("Sagas/PublicContent/saveContactForm/main");
const saveContactFormSuccess = importer(
  "Sagas/PublicContent/saveContactForm/success"
);
const saveContactFormFailure = importer(
  "Sagas/PublicContent/saveContactForm/failure"
);

const getLoyaltyAchievementBadges = importer(
  "Sagas/PublicContent/getLoyaltyAchievementBadges/main"
);
const getLoyaltyAchievementBadgesSuccess = importer(
  "Sagas/PublicContent/getLoyaltyAchievementBadges/success"
);
const getLoyaltyAchievementBadgesFailure = importer(
  "Sagas/PublicContent/getLoyaltyAchievementBadges/failure"
);

const getRedeemPaused = importer("Sagas/PublicContent/getRedeemPaused/main");
const getRedeemPausedSuccess = importer(
  "Sagas/PublicContent/getRedeemPaused/success"
);
const getRedeemPausedFailure = importer(
  "Sagas/PublicContent/getRedeemPaused/failure"
);

const getVendorRedeemPaused = importer(
  "Sagas/PublicContent/getVendorRedeemPaused/main"
);
const getVendorRedeemPausedSuccess = importer(
  "Sagas/PublicContent/getVendorRedeemPaused/success"
);
const getVendorRedeemPausedFailure = importer(
  "Sagas/PublicContent/getVendorRedeemPaused/failure"
);

const drupalMenuFetch = importer("Sagas/PublicContent/drupalMenuFetch/main");
const drupalMenuFetchSuccess = importer(
  "Sagas/PublicContent/drupalMenuFetch/success"
);
const drupalMenuFetchFailure = importer(
  "Sagas/PublicContent/drupalMenuFetch/failure"
);

const getDrupalHomepage = importer(
  "Sagas/PublicContent/getDrupalHomepage/main"
);
const getDrupalHomepageSuccess = importer(
  "Sagas/PublicContent/getDrupalHomepage/success"
);
const getDrupalHomepageFailure = importer(
  "Sagas/PublicContent/getDrupalHomepage/failure"
);

const getPatientTestimonials = importer(
  "Sagas/PublicContent/getPatientTestimonials/main"
);
const getPatientTestimonialsSuccess = importer(
  "Sagas/PublicContent/getPatientTestimonials/success"
);
const getPatientTestimonialsFailure = importer(
  "Sagas/PublicContent/getPatientTestimonials/failure"
);

const getDrupalNavigation = importer(
  "Sagas/PublicContent/getDrupalNavigation/main"
);
const getDrupalNavigationSuccess = importer(
  "Sagas/PublicContent/getDrupalNavigation/success"
);
const getDrupalNavigationFailure = importer(
  "Sagas/PublicContent/getDrupalNavigation/failure"
);

const getFormsPage = importer("Sagas/PublicContent/getFormsPage/main");
const getFormsPageSuccess = importer(
  "Sagas/PublicContent/getFormsPage/success"
);
const getFormsPageFailure = importer(
  "Sagas/PublicContent/getFormsPage/failure"
);

const getCustomPage = importer("Sagas/PublicContent/getCustomPage/main");
const getCustomPageSuccess = importer(
  "Sagas/PublicContent/getCustomPage/success"
);
const getCustomPageFailure = importer(
  "Sagas/PublicContent/getCustomPage/failure"
);

const getPromotionalBanner = importer(
  "Sagas/PublicContent/getPromotionalBanner/main"
);
const getPromotionalBannerSuccess = importer(
  "Sagas/PublicContent/getPromotionalBanner/success"
);
const getPromotionalBannerFailure = importer(
  "Sagas/PublicContent/getPromotionalBanner/failure"
);

const getMobileScreenData = importer(
  "Sagas/PublicContent/getMobileScreenData/main"
);
const getMobileScreenDataSuccess = importer(
  "Sagas/PublicContent/getMobileScreenData/success"
);
const getMobileScreenDataFailure = importer(
  "Sagas/PublicContent/getMobileScreenData/failure"
);

const getOnboardingScreenData = importer(
  "Sagas/PublicContent/getOnboardingScreenData/main"
);
const getOnboardingScreenDataSuccess = importer(
  "Sagas/PublicContent/getOnboardingScreenData/success"
);
const getOnboardingScreenDataFailure = importer(
  "Sagas/PublicContent/getOnboardingScreenData/failure"
);

const getRegistrationPage = importer(
  "Sagas/PublicContent/getDrupalRegistrationPage/main"
);
const getRegistrationPageSuccess = importer(
  "Sagas/PublicContent/getDrupalRegistrationPage/success"
);
const getRegistrationPageFailure = importer(
  "Sagas/PublicContent/getDrupalRegistrationPage/failure"
);

const getLocationsPage = importer("Sagas/PublicContent/getLocationsPage/main");
const getLocationsPageSuccess = importer(
  "Sagas/PublicContent/getLocationsPage/success"
);
const getLocationsPageFailure = importer(
  "Sagas/PublicContent/getLocationsPage/failure"
);

const getCenterDetailsPage = importer(
  "Sagas/PublicContent/getCenterDetailsPage/main"
);
const getCenterDetailsPageSuccess = importer(
  "Sagas/PublicContent/getCenterDetailsPage/success"
);
const getCenterDetailsPageFailure = importer(
  "Sagas/PublicContent/getCenterDetailsPage/failure"
);

const getPostLoginPage = importer("Sagas/PublicContent/getPostLoginPage/main");
const getPostLoginPageSuccess = importer(
  "Sagas/PublicContent/getPostLoginPage/success"
);
const getPostLoginPageFailure = importer(
  "Sagas/PublicContent/getPostLoginPage/failure"
);
const getBlogsPage = importer("Sagas/PublicContent/getBlogsPage/main");
const getBlogsPageSuccess = importer(
  "Sagas/PublicContent/getBlogsPage/success"
);
const getBlogsPageFailure = importer(
  "Sagas/PublicContent/getBlogsPage/failure"
);

const getNewsPage = importer("Sagas/PublicContent/getNewsPage/main");
const getNewsPageSuccess = importer("Sagas/PublicContent/getNewsPage/success");
const getNewsPageFailure = importer("Sagas/PublicContent/getNewsPage/failure");

export default {
  getLanguages,
  getLanguagesSuccess,
  getLanguagesFailure,

  getPhoneTypes,
  getPhoneTypesSuccess,
  getPhoneTypesFailure,

  getEthnicityOptions,
  getEthnicityOptionsSuccess,
  getEthnicityOptionsFailure,

  getLoyaltyMilestones,
  getLoyaltyMilestonesSuccess,
  getLoyaltyMilestonesFailure,

  getMessages,
  getMessagesSuccess,
  getMessagesFailure,

  getCenters,
  getCentersSuccess,
  getCentersFailure,

  getCentersForMobile,
  getCentersForMobileSuccess,
  getCentersForMobileFailure,

  getGenders,
  getGendersSuccess,
  getGendersFailure,

  getCountries,
  getCountriesSuccess,
  getCountriesFailure,

  getAllStates,
  getAllStatesSuccess,
  getAllStatesFailure,

  saveContactForm,
  saveContactFormSuccess,
  saveContactFormFailure,

  getLoyaltyAchievementBadges,
  getLoyaltyAchievementBadgesSuccess,
  getLoyaltyAchievementBadgesFailure,

  getRedeemPaused,
  getRedeemPausedSuccess,
  getRedeemPausedFailure,

  getVendorRedeemPaused,
  getVendorRedeemPausedSuccess,
  getVendorRedeemPausedFailure,

  drupalMenuFetch,
  drupalMenuFetchSuccess,
  drupalMenuFetchFailure,

  getDrupalHomepage,
  getDrupalHomepageSuccess,
  getDrupalHomepageFailure,

  getDrupalNavigation,
  getDrupalNavigationSuccess,
  getDrupalNavigationFailure,

  getPatientTestimonials,
  getPatientTestimonialsSuccess,
  getPatientTestimonialsFailure,

  getFormsPage,
  getFormsPageSuccess,
  getFormsPageFailure,

  getCustomPage,
  getCustomPageSuccess,
  getCustomPageFailure,

  getPromotionalBanner,
  getPromotionalBannerSuccess,
  getPromotionalBannerFailure,

  getRegistrationPage,
  getRegistrationPageSuccess,
  getRegistrationPageFailure,

  getLocationsPage,
  getLocationsPageSuccess,
  getLocationsPageFailure,

  getCenterDetailsPage,
  getCenterDetailsPageSuccess,
  getCenterDetailsPageFailure,

  getPostLoginPage,
  getPostLoginPageSuccess,
  getPostLoginPageFailure,

  getOnboardingScreenData,
  getOnboardingScreenDataSuccess,
  getOnboardingScreenDataFailure,

  getMobileScreenData,
  getMobileScreenDataSuccess,
  getMobileScreenDataFailure,

  getBlogsPage,
  getBlogsPageSuccess,
  getBlogsPageFailure,

  getNewsPage,
  getNewsPageSuccess,
  getNewsPageFailure,
};
